import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { HelpLibraryService } from "../services/help-library.service";
import { HelpItem } from "../models/help-library.model";


@Injectable()
export class HelpLibraryViewResolver  {

    constructor(public helpService: HelpLibraryService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HelpItem> {
        return this.helpService.getHelp(route.paramMap.get("id"), route.paramMap.get("categoryId")).pipe(tap((data) => {
            this.helpService.setActiveNavItem(data);
        }));
    }
}